import React from "react";
import { Badge } from "@nelurio/ui";
import { useI18n } from "@nelurio/i18n";

const stageKeys = ["reviews.initial", "reviews.stage1", "reviews.stage2", "reviews.stage3", "reviews.stage4", "reviews.stage5"];
const dayKeys = ["reviews.day0", "reviews.day1", "reviews.day3", "reviews.day7", "reviews.day15", "reviews.day30"];
const tones = ["blue", "purple", "green", "amber", "coral", "neutral"] as const;

export function ReviewBadge({ stage }: { stage: number }) {
  const { t } = useI18n();
  const safeStage = Math.max(0, Math.min(5, stage));
  return <Badge tone={tones[safeStage]}>{t(stageKeys[safeStage])} · {t(dayKeys[safeStage])}</Badge>;
}
